// Generated by ReScript, PLEASE EDIT WITH CARE


function notNaN(v) {
  if (Number.isNaN(v)) {
    return;
  } else {
    return v;
  }
}

function nonZero(v) {
  if (v === 0) {
    return;
  } else {
    return v;
  }
}

function approxEqual(a, b, epsilon) {
  if (a + b === 0) {
    return a === b;
  } else {
    return Math.abs(a - b) / Math.abs(a + b) < epsilon;
  }
}

export {
  notNaN,
  nonZero,
  approxEqual,
}
/* No side effect */
